<p class="m-t-lg m-b-lg">
  <span class="m-r-xs">{{ authorableData?.prefixText }}</span>
  <span class="text-magenta">
    <a href="javascript:void(0)" (click)="openModal()" id="cta-default-3">{{
      authorableData?.ctaText
    }}</a>
  </span>
  <span class="m-l-xs">{{ authorableData?.suffixText }}</span>
</p>
<tmo-dynamic-modal [modal]="modal">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        tabindex="0"
        [attr.aria-label]="planDetailAEMContent?.clickToClose"
        href="javascript:void(0)"
        class="close-x"
        (click)="closeModal()"
        id="cta-click-to-close"
      >
        <i class="fa fa-times"></i
      ></a>
    </div>
    <h3>{{ authorableData?.modalTitle }}</h3>
  </ng-container>
  <ng-container>
    <div [innerHtml]="authorableData?.modalBody"></div>
  </ng-container>
</tmo-dynamic-modal>
